import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTimePlugin from 'dayjs/plugin/relativeTime'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import 'dayjs/locale/it'

dayjs.extend(relativeTimePlugin)
dayjs.extend(localizedFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)
dayjs.locale('it')

export const fromNow = (date?: string, fromFormat?: dayjs.OptionType) => dayjs(date, fromFormat).fromNow()

// export const datetime = (date: string) => dayjs(date).format('D MMM YYYY H:mm') // 14 Mar 2023 15:09
export const ll = (date?: string, fromFormat?: dayjs.OptionType) => dayjs(date, fromFormat).format('ll') // 14 Mar 2023
export const lll = (date?: string, fromFormat?: dayjs.OptionType) => dayjs(date, fromFormat).format('lll') // 14 Mar 2023 15:09
export const LL = (date?: string, fromFormat?: dayjs.OptionType) => dayjs(date, fromFormat).format('LL') // 14 Marzo 2023
export const LLL = (date?: string, fromFormat?: dayjs.OptionType) => dayjs(date, fromFormat).format('LLL') // 14 Marzo 2023 15:09
export const llll = (date?: string, fromFormat?: dayjs.OptionType) => dayjs(date, fromFormat).format('llll') // martedì 14 marzo 2023 15:09

export const distance = (meters: number | undefined) => {
  if (!meters) return ''
  if (meters < 1000) return `${meters.toFixed(0)} m`
  return `${(meters / 1000).toFixed(2)} km`
}

export const currency = (a?: number) => {
  if (!a) return '0'
  return a
    .toFixed(a % 1 === 0 ? 0 : 2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const noCaps = (a: string) => a.split(' ').map(([first = '', ...rest]) => first.toUpperCase() + rest.map(w => w.toLowerCase()).join('')).join(' ')

// export const shortThousands = (a = 0) => (a < 1000 || a / 100 % 1 !== 0) ? currency(a) : `${(a / 1000).toFixed(a / 1000 % 1 === 0 ? 0 : 1)}k`

// export const ucFirst = (a: string) => a.charAt(0).toUpperCase() + a.slice(1)

// export function letters(str: string) {
//   // if (!str || !str.includes(' ')) return str
//   const parts = str.trim().split(' ')
//   return [
//     parts[0][0].toUpperCase(),
//     (parts.at(-1) || '')[0].toUpperCase(),
//   ].join('')
// }

export function byte(value: number) {
  if (value < 1024) return `${value} byte`
  else if (value < 1024 ** 2) return `${(value / 1024).toFixed(1)} KB`
  else if (value < 1024 ** 3) return `${(value / (1024 ** 2)).toFixed(1)} MB`
  else if (value < 1024 ** 4) return `${(value / (1024 ** 3)).toFixed(1)} GB`
  return ''
}
